// import _ from 'lodash';
// import React, {Component} from 'react';
import Swal from 'sweetalert2';

const UNAllValidRegex = /^[a-zA-Z]+[a-zA-Z0-9._-]*$/;
const UNValidStartRegex = /^[a-zA-Z]+/;
const FNValidRegex = /^[a-zA-Z\s]+$/;
const LocValidRegex = /^[a-zA-Z\s,-]+$/;
const spacesRegex = /\s+/;

export const alertChangeFullName = async ({nameInput, loading, updateUserInfoCb}) => {
  // const editNameField = this.state;
  const {value: newName} = await Swal({
    title: 'Change name?',
    text: 'Please enter your new full name',
    // footer: '<a href>Why do I have this issue?</a>',
    input: 'text',
    inputValue: nameInput,
    showCancelButton: true,
    reverseButtons: true,
    inputValidator: value => nameValidator(value),
    // showLoaderOnConfirm: true,
    allowOutsideClick: !loading,
  });

  if (newName) {
    // Swal('Saved!', `Your new name is ${newName}`, 'success');
    updateUserInfoCb({'name': newName});
  }
};

export const alertChangeUserLoc = async ({locInput, loading, updateUserInfoCb}) => {
  // const editNameField = this.state;
  const {value: newLoc} = await Swal({
    title: 'Update your location?',
    text: 'Where in the world are you?!',
    // footer: '<a href>Why do I have this issue?</a>',
    input: 'text',
    inputValue: locInput,
    showCancelButton: true,
    reverseButtons: true,
    inputValidator: value => locValidator(value),
    // showLoaderOnConfirm: true,
    allowOutsideClick: !loading,
  });

  if (newLoc) {
    console.log('did we updated ;loc??', newLoc);
    // NOTE key must match expected api!!
    updateUserInfoCb({'location': newLoc});
  }
};

export const alertChangeUserName = async ({unameInput, loading, updateUserInfoCb}) => {
  // const {editUserNameField, swalEditUserLoading} = this.state;
  const {value: newUName} = await Swal({
    title: 'Change username?',
    text: 'Please enter the new username',
    // footer: '<a href>Why do I have this issue?</a>',
    input: 'text',
    inputValue: unameInput, // is this actually being used? lol
    showCancelButton: true,
    reverseButtons: true,
    // showLoaderOnConfirm: true,
    allowOutsideClick: !loading,
    // onConfirm: swal.showLoading(),
    inputValidator: value => userNameValidator(value),
  });

  if (newUName) {
    // NOTE key must match expected api!!
    updateUserInfoCb({'username': newUName});
  }
};

// NOTE TODO REFACTOR these functions!! they are mostly all the same...
export const alertChangeUserBio = async ({bioInput, loading, updateUserInfoCb}) => {
  // const {editUserNameField, swalEditUserLoading} = this.state;
  const {value: newBio} = await Swal({
    title: 'Describe Yourself!',
    text: 'What would you like your poll pals to know about you?',
    // footer: '<a href>Why do I have this issue?</a>',
    input: 'textarea',
    inputValue: bioInput, // is this actually being used? lol
    showCancelButton: true,
    reverseButtons: true,
    // showLoaderOnConfirm: true,
    allowOutsideClick: !loading,
    // onConfirm: swal.showLoading(),
    inputValidator: value => bioValidator(value),
  });

  if (newBio) {
    // NOTE key must match expected api!!
    updateUserInfoCb({'about': newBio});
  }
};

export const alertChangePollDescr = async ({descrInput, loading, updatePollDescrCb}) => {
  // const {editUserNameField, swalEditUserLoading} = this.state;
  const {value: newDescr} = await Swal({
    title: 'Describe your Poll!',
    text: 'What was your inspiration? Want to give others background information?',
    // footer: '<a href>Why do I have this issue?</a>',
    input: 'textarea',
    inputValue: descrInput, // placeholder??
    showCancelButton: true,
    reverseButtons: true,
    // showLoaderOnConfirm: true,
    allowOutsideClick: !loading,
    // onConfirm: swal.showLoading(),
    inputValidator: value => pollDescrValidator(value, descrInput),
  });

  if (newDescr) {
    // NOTE key must match expected api!!
    updatePollDescrCb({'descrip': newDescr});
  }
};

const pollDescrValidator = (pdescr_input, oldDescr) => {
  const input = pdescr_input.trim();
  if (!input) {
    return 'This is manditory! Give fellow pollers some background info about the subject, or what inspired you to make this poll :)';
  } else if(input.length > 300 ) {
    return 'Please keep it brief :) limit it to 300 characters.';
  } else if(input.length < 10) {
    return 'Thats a bit too short! Please enter some more info :)';
  }
  // TODO DEBUG add this check later, after all polls have a descrip
  // else if(input == oldDescr) {
  //   return "You didn't change anything!!";
  // }
};

const bioValidator = (bio_input) => {
  const input = bio_input.trim();
  if (!input) {
    return 'There must be something intersting about you! Tell us!!';
  } else if(input.length > 800) {
    return 'You have a lot to say about yourself! Please limit it to 800 characters.';
  } else if(input.length < 5) {
    return 'That a short bio! Please enter just a tiny bit more :)';
  }
};

const nameValidator = (name_input) => {
  const input = name_input.trim();
  if (!input) {
    return 'What do you want to change it to?!';
  } else if (input.match(FNValidRegex) === null) {
    return 'Invalid! Your name can only contain alphanumeric characters (A-Z), and spaces';
  } else if(input.length > 80) {
    return 'Invalid! Please enter your name in less than 80 characters!';
  } else if(input.length < 5) {
    return 'Invalid! Please enter your entire full name!';
  }
};

const locValidator = (name_input) => {
  const input = name_input.trim();
  if (!input) {
    return 'What do you want to change it to?!';
  } else if (input.match(LocValidRegex) === null) {
    return 'Invalid! Your name can only contain alphanumeric characters (A-Z), spaces, "-", or ","';
  } else if(input.length > 20) {
    return 'Invalid! Must be less than 20 characters :) Keep it short!';
  } else if(input.length < 3) {
    return 'Invalid! Too short!!';
  }
};

const userNameValidator = (uname_input) => {
  const input = uname_input.trim();
  const lower_uname = input.toLowerCase();
  if (!input) {
    return 'What do you want to change it to?!';
  } else if (input.match(UNValidStartRegex) === null) {
    return 'Invalid! New username must start with an alphanumeric character (a-z)';
  } else if (input.match(spacesRegex) !== null) {
    return 'Invalid! New username cannot contain spaces!';
  } else if (input.match(UNAllValidRegex) === null) {
    return 'Invalid! Usernames can only use alphanumeric characters (a-z), numbers (0-9), ".", "-", or "_"';
  } else if(input.length > 40) {
    return 'Invalid! New username cannot be longer than 40 characters!';
  } else if(input.length < 6) {
    return 'Invalid! New username must be at least 6 characters!';
  } else if (input !== lower_uname) {
    return 'The username must ONLY have lowercase letters :)';
  }
};

// // AJAX EX
// Swal.fire({
//   title: 'Submit your Github username',
//   input: 'text',
//   inputAttributes: {
//     autocapitalize: 'off'
//   },
//   showCancelButton: true,
//   confirmButtonText: 'Look up',
//   showLoaderOnConfirm: true,
//   preConfirm: (login) => {
//     return fetch(`//api.github.com/users/${login}`)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error(response.statusText)
//         }
//         return response.json()
//       })
//       .catch(error => {
//         Swal.showValidationMessage(
//           `Request failed: ${error}`
//         )
//       })
//   },
//   allowOutsideClick: () => !Swal.isLoading()
// }).then((result) => {
//   if (result.value) {
//     Swal.fire({
//       title: `${result.value.login}'s avatar`,
//       imageUrl: result.value.avatar_url
//     })
//   }
// })

  // const deleteFileEx = Swal({
  //   title: 'Are you sure?',
  //   text: 'You will not be able to recover this imaginary file!',
  //   type: 'warning',
  //   showCancelButton: true,
  //   confirmButtonText: 'Yes, delete it!',
  //   cancelButtonText: 'No, keep it'
  // }).then((result) => {
  //   if (result.value) {
  //     Swal(
  //       'Deleted!',
  //       'Your imaginary file has been deleted.',
  //       'success'
  //     )
  //   // For more information about handling dismissals please visit
  //   // https://sweetalert2.github.io/#handling-dismissals
  //   } else if (result.dismiss === Swal.DismissReason.cancel) {
  //     Swal(
  //       'Cancelled',
  //       'Your imaginary file is safe :)',
  //       'error'
  //     )
  //   }
  // });
  // return deleteFileEx;
  // }



// WEBPACK FOOTER //
// ./src/views/SweetAlerts.js